export let DomainIntentReferral = /*#__PURE__*/function (DomainIntentReferral) {
  DomainIntentReferral["PURCHASE"] = "add-domain-purchase-intent";
  DomainIntentReferral["PURCHASE_FUNNEL"] = "add-domain-purchase-intent-funnel";
  DomainIntentReferral["PURCHASE_STOREFRONT"] = "add-domain-purchase-intent-storefront";
  DomainIntentReferral["CONNECT"] = "add-domain-connect-intent";
  DomainIntentReferral["CONNECT_FUNNEL"] = "add-domain-connect-intent-funnel";
  DomainIntentReferral["ASSIGN"] = "add-domain-assign-intent";
  return DomainIntentReferral;
}({});
export const isFunnelReferral = referralAdditionalInfo => referralAdditionalInfo === DomainIntentReferral.PURCHASE_FUNNEL || referralAdditionalInfo === DomainIntentReferral.CONNECT_FUNNEL;
//# sourceMappingURL=domainIntentReferral.js.map